import { ReactNode, useEffect } from 'react';

import { removeAppShell } from './removeAppShell';

export function AppShellReady({ children }: { children: ReactNode }) {
  useEffect(() => {
    const id = requestAnimationFrame(removeAppShell);
    return () => cancelAnimationFrame(id);
  }, []);
  return <>{children}</>;
}
